import React from "react";
import { Col, Container, Row } from "reactstrap";
import { useRef, useState } from "react";
import ProtectionImage from "../../Assets/Images/protection-image.jpg";
import CashValueImage from "../../Assets/Images/cash-value-image.jpg";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import Protection from "./Protection";
import CashValue from "./CashValue";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const componentMap = {
  PROTECTION: <Protection isScrollable={true} />,
  CASHVALUE: <CashValue isScrollable={true} />,
};
const ProtectionPlusPolicyTab = ({ sectionRef }) => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();

  const [change, setChange] = useState("PROTECTION");

  return (
    <div
      id="Benefits"
      ref={sectionRef}
      className="supeior-rating py-12 md:pt-12 md:pb-12 lg:pt-16 lg:pb-16 lg:min-h-[100vh] lg:flex lg:items-center mt-[50px] !mb-[110px] md:my-[10px] md:!mb-[10px] lg:my-0 lg:!mb-0"
    >
      <div className="tab-capsule-img-box relative lg:absolute w-[100%] lg:w-[50%] pl-[20px] right-0 lg:block hidden universalBenifits-image">
        <div className="tab-capsule-inner-box flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
          <div className="circle-div ml-[20px] lg:ml-0 mb-[10%] md:mb-0 max-h-[688px] reveal-up">
            <img
              src={change === "PROTECTION" ? ProtectionImage : CashValueImage}
              width={"100%"}
              className="object-cover "
              alt=""
            />
          </div>
        </div>
      </div>
      <Container>
        <div className="">
          <div className="mt-0 reveal-up max-w-[460px] lg:pl-0 pl-4">
            <div className="text-[12px] leading-[19px] tracking-[-0.24px] lg:text-[16px] lg:leading-normal lg:tracking-normal font-normal mb-2 lg:mb-4 block reveal-up">
              {translations.universeProduct_subtitle}
            </div>
            <h2
              className="lg:text-[2.5rem] lg:leading-[2.8rem] md:text-[30px] md:leading-[33px] text-[24px] leading-[28px] tracking-[-0.48px] md:tracking-[-0.6px] lg:tracking-normal lg:mb-8 mb-4 font-normal reveal-up reveal-delay-1"
              dangerouslySetInnerHTML={{
                __html: translations.universeProduct_heading,
              }}
            ></h2>
            <div className="active-section flex lg:justify-center justify-space-between gap-2 bg-white rounded-full mt-4 mb-5 lg:mb-4 max-w-[260px]">
              <button
                onClick={() => setChange("PROTECTION")}
                className={`flex-1 content ${
                  change === "PROTECTION" ? "active bg-[#0D4248]" : ""
                } font-medium  ${
                  change === "PROTECTION" ? "text-white" : "text-black"
                } py-3 px-4 rounded-full w-1/3`}
              >
                {translations.universeProtection_tab}
              </button>
              <button
                onClick={() => setChange("CASHVALUE")}
                className={`flex-1 content ${
                  change === "CASHVALUE" ? "active bg-[#0D4248]" : ""
                } font-medium  ${
                  change === "CASHVALUE" ? "text-white" : "text-black"
                } py-3 px-4 rounded-full w-1/3`}
              >
                {translations.universeCashValue_tab}
              </button>
            </div>
          </div>
          {componentMap[change] || null}
        </div>
      </Container>
    </div>
  );
};

export default ProtectionPlusPolicyTab;
